var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TextContent',{attrs:{"fontSize":"20px","lineHeight":"28px","color":"var(--tertiary-color)","fontWeight":"600"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }